import { PencilAltIcon, PencilIcon } from "@heroicons/react/solid";
import { FormEvent } from "react";
import Footer from "../components/footer";
import NavBar from "../components/navbar";
import NewThread from "../components/newthread";
import { Button } from "semantic-ui-react";

const CreateThread = () => {
    
  

  return (
    <>
      <NavBar />
      <div className="mt-36 flex flex-col justify-center place-items-center max-h-screen">
          <NewThread />
      </div>
      <Footer />
    </>
  );
};

export default CreateThread;
